import React from "react";
import { FileSpreadsheet, ShieldCheck, Landmark } from "lucide-react";
import PageHeader from "../../components/PageHeader";

const Fiscal = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumb="Financeiro & Integrações"
        title="Configuração Fiscal"
        subtitle="Gerenciamento do perfil fiscal, emissor e notas fiscais eletrônicas (NF-e)"
      />

      <div className="neumorphic-card rounded-2xl p-8 border border-white/5 space-y-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-purple-500/10 border border-purple-500/20 text-purple-400 flex items-center justify-center">
            <FileSpreadsheet size={24} />
          </div>
          <div>
            <h3 className="text-base font-bold text-white">Módulo em Integração</h3>
            <p className="text-xs text-gray-400 mt-0.5">
              Conexão com os servidores de emissão fiscal automática
            </p>
          </div>
        </div>

        <div className="p-4 rounded-xl bg-white/5 border border-white/5 space-y-3 text-xs text-gray-300">
          <span className="font-bold text-gray-200 uppercase tracking-wider text-[11px] block">
            Funcionalidades Previstas:
          </span>
          <ul className="space-y-2">
            <li className="flex items-center gap-2">
              <Landmark size={14} className="text-purple-400" />
              <span>Cadastro do CNPJ emissor, Inscrição Municipal e certificado digital A1</span>
            </li>
            <li className="flex items-center gap-2">
              <FileSpreadsheet size={14} className="text-purple-400" />
              <span>Automação da emissão de NFS-e após confirmação de pagamento</span>
            </li>
            <li className="flex items-center gap-2">
              <ShieldCheck size={14} className="text-purple-400" />
              <span>Validação e checagem de prontidão fiscal prévia</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Fiscal;
